import React from "react";
import '../../../css/table.css'

function CommonTable(props) {
    const { headerTitle, children, columnWidths } = props;

    return (
        <table className="common-table">
            {columnWidths && (
                <colgroup>
                    {columnWidths.map((width, index) => (
                        <col key={index} style={{ width: width }} />
                    ))}
                </colgroup>
            )}
            <thead>
                <tr>
                    {
                        headerTitle.map((item, index) => {
                            return (
                                <td className="common-table-header-column" key={index}>{item}</td>
                            )
                        })
                    }
                </tr>
            </thead>
            <tbody>
                {children}
            </tbody>
        </table>
    )
}

export default CommonTable;